import { formatTimerClock, timerClockSample } from '../../lib/timerClockFormat';
import { FittedText } from './TimerHeader';
import { THEMES, type ThemeTokens } from '../../lib/timerThemes';

export function TimerCountdown({
  seconds,
  isBreak,
  isWarning = false,
  statusLabel,
  theme,
  fontSize,
}: {
  seconds: number;
  isBreak: boolean;
  isWarning?: boolean;
  statusLabel?: string;
  theme: ThemeTokens;
  fontSize: number;
}) {
  const color = isBreak ? '#ffffff' : isWarning ? theme.timerWarningColor : theme.timerColor;
  const isCustom = theme === THEMES.custom;
  return (
    <div
      className="flex flex-col items-center justify-center h-full w-full min-w-0 min-h-0 relative p-2"
      style={{ backgroundColor: isBreak ? '#b91c1c' : undefined }}
    >
      <div
        className="absolute inset-0"
        style={{
          background:
            isBreak || isCustom
              ? 'none'
              : `radial-gradient(ellipse at center, ${color}10 0%, transparent 70%)`,
        }}
      />
      {statusLabel && (
        <div
          className="relative z-10 w-full shrink-0"
          style={{ height: fontSize * 0.18, maxHeight: '25%' }}
        >
          <FittedText text={statusLabel} size={fontSize * 0.18} color={color} />
        </div>
      )}
      {isBreak && (
        <div
          className="relative z-10 w-full shrink-0"
          style={{ height: fontSize * 0.25, maxHeight: '25%' }}
        >
          <FittedText text="Break" size={fontSize * 0.25} color={color} />
        </div>
      )}
      <FittedText
        text={formatTimerClock(seconds)}
        measurementText={timerClockSample(seconds)}
        size={fontSize}
        color={color}
        className="relative z-10 font-black leading-none tracking-tight"
        style={{
          fontVariantNumeric: 'tabular-nums',
          letterSpacing: theme.letterSpacing,
          fontFamily: isCustom ? 'var(--font-display)' : theme.fontFamily,
          textShadow: isBreak || isCustom ? 'none' : `0 0 60px ${color}40`,
        }}
      />
    </div>
  );
}
